<template>
  <main-sidebar :name="name" :title="$t('bank_account')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('bank') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.bank"
            :options="banks"
            class="w-full"
            :reduce="(item) => item.id"
            label="short_name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('account') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input
            class="w-full"
            v-model="form.account"
            name="account"
            autocomplete="off"
            v-validate="'required|length:18'"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <span class="text-danger text-sm" v-show="errors.has('account')">{{
            errors.first('account')
          }}</span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('currency') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.currency"
            :options="currencies"
            class="w-full"
            :reduce="(currency) => currency.id"
            label="name"
          />
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-w="12">
          <vs-button
            color="primary"
            type="filled"
            class="mr-6"
            @click="isEditing ? update() : store()"
            :disabled="disabledSubmit"
          >
            {{ $t('save') }}
          </vs-button>
          <vs-button color="primary" type="border" @click="close">
            {{ $t('cancel') }}
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate.js'
import request from '../request'
export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    vendorId: {
      required: true,
    },
    banks: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        bank: '',
        account: '',
        currency: '',
      },
      currencies: [
        { id: 'USD', name: 'USD' },
        { id: 'MXN', name: 'MXN' },
      ],
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit
    },
    disabledSubmit() {
      return (
        this.errors.any() ||
        this.form.bank === '' ||
        this.form.account === '' ||
        this.form.currency === ''
      )
    },
    isEditing() {
      return Object.keys(this.data).length > 0
    },
  },
  methods: {
    clear() {
      this.form.bank = ''
      this.form.account = ''
      this.form.currency = ''
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.clear()
      if (this.isEditing) {
        this.form.bank = this.data.bank_id
        this.form.account = this.data.number
        this.form.currency = this.data.currency
      }
    },
    store() {
      const payload = {
        vendor_id: this.vendorId,
        bank_id: this.form.bank,
        number: this.form.account,
        currency: this.form.currency,
      }
      this.openLoading(`loading-${this.name}-sidebar`)
      request
        .addAccount(payload)
        .then((response) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Account Saved',
          })
          this.$emit('success')
          this.close()
        })
        .catch((response) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.showValidationErrors(response)
        })
    },
    update() {
      const payload = {
        bank_id: this.form.bank,
        number: this.form.account,
        currency: this.form.currency,
      }
      this.openLoading(`loading-${this.name}-sidebar`)
      request
        .updateAccount(this.data.account_id, payload)
        .then((response) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Account Updated',
          })
          this.$emit('success')
          this.close()
        })
        .catch((response) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.showValidationErrors(response)
        })
    },
  },
  mixins: [loading, validate],

  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
  },
}
</script>

<style>
</style>